<template>
<van-nav-bar
  v-if="!noShowHeader"
  class="k-header-bar"
  :style="barStyles"
>
  <template #title>
    <slot>
      <span class="title-text" :style="{ color: ftColor || '#333333' }">{{ titleText }}</span>
    </slot>
  </template>
  <template #left v-if="showBack">
    <slot name="left">
      <van-icon class="left-icon" name="arrow-left" :color="ftColor || '#333333'" @click="handleBackClick" />
    </slot>
  </template>
  <template #right>
    <slot name="right" @click="rightClick"></slot>
  </template>
</van-nav-bar>
</template>

<script setup lang="ts">
interface IProps {
  titleText?: string,
  ftColor?: string,
  bgColor?: string,
  leftClick?: () => void,
  rightClick?: () => void,
  showBack?: boolean,
  noShowHeader?: boolean,
  bgImg?:string
}

const props = withDefaults(defineProps<IProps>(), {
  showBack: true,
  ftColor: '#333333',
  rightClick: () => {}
})

const barStyles = computed(() => {
  const styles: IAnyObject = {}
  if(props.bgColor) {
    styles.backgroundColor = props.bgColor
  }
  if(props.bgImg) {
    styles.backgroundImage = `url(${props.bgImg})`
  }

  return styles
})
const router = useRouter()

const handleBackClick = () => {
  if(props.leftClick) {
    props.leftClick()
  } else {
    router.back()
  }
}
</script>

<style lang="scss" scoped>
.back-icon{
  font-size: 28px;
}
.left-icon{
  font-size: 40px;
}
.k-header-bar{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: transparent;
  z-index: 509;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>